import { render, staticRenderFns } from "./Logos.vue?vue&type=template&id=51567fdb&scoped=true&"
import script from "./Logos.vue?vue&type=script&lang=js&"
export * from "./Logos.vue?vue&type=script&lang=js&"
import style0 from "./Logos.vue?vue&type=style&index=0&id=51567fdb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51567fdb",
  null
  
)

export default component.exports